import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import Synergy from '@/roc/wonders/base/Synergy';
import EraType from '@/roc/era/EraType';

const ChichenItza = {
  id: '58',
  name: 'Chichen Itza',
  era: EraType.earlyRome,
  icon: 'ci',
  gameId: 'ChichenItza',
  minLevel: 1,
  maxLevel: 30.0,
  type: WonderType.GREAT_EMPIRE,
  kind: WonderKind.ARENA | WonderKind.TEMPLE,
  kindMultiplier: 1,
  owner: WonderOwner.MAYA,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.RANGED_CRITICAL_HIT_CHANCE_MOD,
      EffectAmount.asPerLevel([
        25.0,
        35.0,
        43.0,
        49.0,
        54.0, //5
        59.0,
        64.0,
        68.0,
        72.0,
        75.0, //10
        79.0,
        82.0,
        85.0,
        88.0,
        91.0, //15
        94.0,
        96.0,
        99.0,
        101.0,
        104.0, //20
        106.0,
        108.0,
        111.0,
        113.0,
        115.0, //25
        117.0,
        119.0,
        121.0,
        123.0,
        125.0 // 30
      ]),
      '%',
    ),
    new PassiveAura(
      PassiveAuraType.MAYA_ARCHERS_PRODUCTION_TIME_BONUS,
      EffectAmount.asPerLevel([
        5,
        11.2,
        14.8,
        17.4,
        19.3,  // 5
        21.0,
        22.3,
        23.6,
        24.9,
        26.2,  // 10
        27.5,
        28.8,
        30.1,
        31.4,
        32.7,  // 15
        34.0,
        35.3,
        36.6,
        37.9,
        39.2,  // 20
        40.5,
        40.9,
        41.4,
        41.8,
        42.3,  // 25
        42.7,
        43.2,
        43.6,
        44.1,
        44.5 //30
      ]),
      '%',
    ),
  ]),
  synergies: [
    {
      effectIndex: 0,
      mod: Synergy.asFlat(15.0).withKind(WonderKind.ARENA),
      effect: null,
    }
  ],
};

export default ChichenItza;
